import React from 'react';
import { useNavigate } from 'react-router-dom';

const HomeButton = ({menuState, setMenuState}) => {
    const [bhHovered, setBhHovered] = React.useState(false);
    const navigate = useNavigate();
   

    const baseSize = 20; // Adjust this value to set the base size of your image
    const hoverIncrease = 2;

    return (
        <div 
            className={`boutonHome `}
            style={{
                position: 'absolute',
                top: '465px',
                left: '25px',
                zIndex: '10',
                cursor: 'pointer',
                width: bhHovered ? `${baseSize + hoverIncrease}px` : `${baseSize}px`,
                height: bhHovered ? `${baseSize + hoverIncrease}px` : `${baseSize}px`,
                transition: 'width 0.3s, height 0.3s',
                
                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/home.png)`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
            onMouseEnter={() => {
                setBhHovered(true);
            }}
            onMouseLeave={() => {
                setBhHovered(false);
            }}
            onClick={() => {
                //window.parent.location.href = 'https://digitaljazz.fr/clesdecoute'+'/menu/'
                navigate(process.env.PUBLIC_URL +  '/menu2/');
                
            }}
        />
    );
}

export default HomeButton;